module.exports = __webpack_public_path__ + "static/media/online-store.fe620940.png";